import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { HOME_MODULE } from '../constants';
import { Get } from '../../utils/httpProvider';
import { HOME_API } from '../../utils/apiUrl';

export const homeGetPhatTrienPhanMemAction = createAsyncThunk(
  HOME_MODULE.GET_PHAT_TRIEN_PHAN_MEM,
  async ({ From = '', To = '' } = {}, { rejectWithValue }) => {
    try {
      const url = HOME_API.GET_PHAT_TRIEN_PHAN_MEM({ From, To });
      const res = await Get(url);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const homeGetXuLyYeuCauAction = createAsyncThunk(
  HOME_MODULE.GET_XU_LY_YEU_CAU,
  async ({ From = '', To = '' } = {}, { rejectWithValue }) => {
    try {
      const url = HOME_API.GET_XU_LY_YEU_CAU({ From, To });
      const res = await Get(url);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const homeGetHoTroAction = createAsyncThunk(
  HOME_MODULE.GET_HO_TRO,
  async ({ From = '', To = '' } = {}, { rejectWithValue }) => {
    try {
      const url = HOME_API.GET_HO_TRO({ From, To });
      const res = await Get(url);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const homeGetNhiemVuKhacAction = createAsyncThunk(
  HOME_MODULE.GET_NHIEM_VU_KHAC,
  async ({ From = '', To = '' } = {}, { rejectWithValue }) => {
    try {
      const url = HOME_API.GET_NHIEM_VU_KHAC({ From, To });
      const res = await Get(url);
      return res;
    } catch (error) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

const initialState = {
  // PTPM
  phatTrienPhanMemSummary: null,
  loadingPhatTrienPhanMemSummary: false,
  errorPhatTrienPhanMemSummary: null,

  // Xử lý yêu cầu
  xuLyYeuCauSummary: null,
  loadingXuLyYeuCauSummary: false,
  errorXuLyYeuCauSummary: null,

  hoTroSummary: null,
  loadingHoTroSummary: false,
  errorHoTroSummary: null,

  nhiemVuKhacSummary: null,
  loadingNhiemVuKhacSummary: false,
  errorNhiemVuKhacSummary: null,
};

export const homeSlice = createSlice({
  name: HOME_MODULE.NAME_SLICE,
  initialState,
  reducers: {
    homeClearPhatTrienPhanMem: (state) => {
      state.phatTrienPhanMemSummary = null;
      state.loadingPhatTrienPhanMemSummary = false;
      state.errorPhatTrienPhanMemSummary = null;
    },
    homeClearXuLyYeuCau: (state) => {
      state.xuLyYeuCauSummary = null;
      state.loadingXuLyYeuCauSummary = false;
      state.errorXuLyYeuCauSummary = null;
    },

    homeClearHoTro: (state) => {
        state.hoTroSummary = null;
        state.loadingHoTroSummary = false;
        state.errorHoTroSummary = null;
    },

    homeClearNhiemVuKhac: (state) => {
        state.nhiemVuKhacSummary = null;
        state.loadingNhiemVuKhacSummary = false;
        state.errorNhiemVuKhacSummary = null;
    },
  },
  extraReducers: (builder) => {
    // PTPM
    builder
      .addCase(homeGetPhatTrienPhanMemAction.pending, (state) => {
        state.loadingPhatTrienPhanMemSummary = true;
        state.errorPhatTrienPhanMemSummary = null;
      })
      .addCase(homeGetPhatTrienPhanMemAction.fulfilled, (state, action) => {
        state.loadingPhatTrienPhanMemSummary = false;
        state.phatTrienPhanMemSummary = action.payload;
      })
      .addCase(homeGetPhatTrienPhanMemAction.rejected, (state, action) => {
        state.loadingPhatTrienPhanMemSummary = false;
        state.errorPhatTrienPhanMemSummary = action.payload || action.error;
      });

    // Xử lý yêu cầu
    builder
      .addCase(homeGetXuLyYeuCauAction.pending, (state) => {
        state.loadingXuLyYeuCauSummary = true;
        state.errorXuLyYeuCauSummary = null;
      })
      .addCase(homeGetXuLyYeuCauAction.fulfilled, (state, action) => {
        state.loadingXuLyYeuCauSummary = false;
        state.xuLyYeuCauSummary = action.payload;
      })
      .addCase(homeGetXuLyYeuCauAction.rejected, (state, action) => {
        state.loadingXuLyYeuCauSummary = false;
        state.errorXuLyYeuCauSummary = action.payload || action.error;
      });

    // Hỗ trợ phần mềm
    builder
        .addCase(homeGetHoTroAction.pending, (state) => {
            state.loadingHoTroSummary = true;
            state.errorHoTroSummary = null;
        })
        .addCase(homeGetHoTroAction.fulfilled, (state, action) => {
            state.loadingHoTroSummary = false;
            state.hoTroSummary = action.payload;
        })
        .addCase(homeGetHoTroAction.rejected, (state, action) => {
            state.loadingHoTroSummary = false;
            state.errorHoTroSummary = action.payload || action.error;
        });

    builder
        .addCase(homeGetNhiemVuKhacAction.pending, (state) => {
            state.loadingNhiemVuKhacSummary = true;
            state.errorNhiemVuKhacSummary = null;
        })
        .addCase(homeGetNhiemVuKhacAction.fulfilled, (state, action) => {
            state.loadingNhiemVuKhacSummary = false;
            state.nhiemVuKhacSummary = action.payload;
        })
        .addCase(homeGetNhiemVuKhacAction.rejected, (state, action) => {
            state.loadingNhiemVuKhacSummary = false;
            state.errorNhiemVuKhacSummary = action.payload || action.error;
        });
  },
});

export const {
  homeClearPhatTrienPhanMem,
  homeClearXuLyYeuCau,
  homeClearHoTro,
  homeClearNhiemVuKhac, 
} = homeSlice.actions;

export default homeSlice.reducer;
